import React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { routesAllowedForFutureYears, validateSearchParams } from "../utils/ValidationUtils";

/**
 * Props for the ValidatorRouteWrapper component.
 */
interface ValidatorRouteWrapperProps extends RouteProps {
  children: JSX.Element;
}

/**
 * Wrapper component for validating search parameters and rendering child components.
 * If the search parameters are invalid, it redirects to the "/dashboard" route.
 */
const ValidatorRouteWrapper: React.FC<ValidatorRouteWrapperProps> = ({
  children,
  path
}) => {
  const allowFutureYears = routesAllowedForFutureYears.find(route => route.toString() === path);
  const params = new URLSearchParams(window.location.search);
  const isValidParams = validateSearchParams(params, !!allowFutureYears);

  if (!isValidParams) {
    return <Redirect to="/dashboard" />;
  }

  return children;
};

export default ValidatorRouteWrapper;
